<template>
  <div>
    <PageTitle
      title="Reservations"
      :btnCreate="flase"
      :createRoute="'/room/add'"
      :permission="'Product Create'"
    />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['search', 'dateRange', 'orderstatus', 'guest', 'biller']"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>
      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="reservations"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.date="{ item }">{{
                  item.date | formatDate
                }}</template>
                <template v-slot:item.reference_number="{ item }">
                  <CopyTableCell :text="item.reference_number"></CopyTableCell>
                </template>
                <!-- No -->
                <template v-slot:item.no>
                  <v-icon>mdi-vuetify</v-icon>
                </template>
                <!-- Status -->
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 cursor-pointer"
                    label
                    text-color="white"
                    :color="GetStatusColor(item.status)"
                    dark
                    >{{ item.status }}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="reservation"
                    :item="item"
                    viewPermission="Room Show"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="hms/reservations"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";
import TableFilters from "@/components/base/TableFilters";
import moment from "moment";

import { required, email, max } from "vee-validate/dist/rules";
import { mapGetters } from "vuex";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import BrandAutoComplete from "@/components/base/BrandAutoComplete";
import CategoryAutoComplete from "@/components/base/CategoryAutoComplete";
import StatusAutoComplete from "@/components/base/StatusAutoComplete";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    paginationOptions: {},

    columns: [
      {
        text: "Date",
        value: "date",
        show: true,
        disabled: true,

        width: "12.1%",
      },
      {
        text: "Reference Number",
        value: "reference_number",
        show: true,
        disabled: true,

        width: "12.1%",
      },
      {
        text: "Total Amount",
        value: "total_amount",
        align: "left",
        show: true,
        disabled: true,
        width: "12.1%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "12.1%",
      },
      {
        text: "Order Total Amount",
        value: "order_total_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "13%",
      },
      {
        text: "Guest",
        value: "guest.name",
        show: true,
        align: "left",
        disabled: false,
        width: "10%",
      },
      // {
      //   text: "User",
      //   value: "user.first_name",
      //   show: true,
      //   align: "left",
      //   disabled: false,
      //   width: "12.1%",
      // },

      {
        text: "Status",
        value: "status",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
    ],
    reservations: [],
    // Filters
    filter: {
      category: "",
      search: "",
      brand: "",
      status: "",
    },
  }),
  components: {
    PageTitle,
    ValidationProvider,
    ValidationObserver,
    pagination,
    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    setResponseData(reservations) {
      this.reservations = reservations;
      //   this.rooms.map((u) => {
      //     if (u.image) {
      //       u.image = u.image + "?t=" + new Date().getTime();
      //     }
      //   });
    },
    clearFilter() {
      this.filter = {};
    },
    GetStatusColor(status) {
      switch (status) {
        case "Paid":
          return "green";
          break;
        case "PartiallyPaid":
          return "orange";
          break;
        case "Cancelled":
        case "Canceled":
          return "red";
          break;
        default:
          break;
      }
    },
    EditModal(item) {
      this.$router.push({ path: "/product/edit/" + item.id });
    },
  },
  computed: {
    ...mapGetters("product", ["GetAllProducts"]),
    // Filter - return selected table fields
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  filters: {
    formatDate(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>
